import { Link } from 'react-router-dom';

export default function WTBHero() {
  return (
    <section className="relative bg-[#0B2C26] pt-28 pb-20 overflow-hidden">
      <div className="absolute inset-0 opacity-15">
        <img
          src="https://public.readdy.ai/ai/img_res/73c392895283b08eae364a7b84ac5b72.jpg"
          alt="Global distribution map"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-[#FF6B35]/20 border border-[#FF6B35]/40 rounded-full px-4 py-1.5 mb-5">
          <i className="ri-global-line text-[#FF6B35] text-sm" />
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Worldwide Availability</span>
        </div>
        <h1 className="text-4xl md:text-6xl font-black text-white mb-5">
          Available Worldwide —<br />
          <span className="text-[#FF6B35]">Find PHIX Doctor Near You</span>
        </h1>
        <p className="text-stone-400 text-lg max-w-xl mx-auto mb-10">
          1,200+ retail locations in 60+ countries. Online ordering with worldwide express shipping.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 max-w-2xl mx-auto mb-10">
          {[['1,200+', 'Retail Locations'], ['60+', 'Countries'], ['24hr', 'Online Shipping'], ['#1', 'Rated Repair Kit']].map(([v, l]) => (
            <div key={l} className="bg-white/10 border border-white/15 rounded-2xl p-4 text-center">
              <p className="text-[#FF6B35] font-black text-2xl">{v}</p>
              <p className="text-stone-400 text-xs uppercase tracking-wider mt-1">{l}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#store-finder" className="whitespace-nowrap bg-[#FF6B35] text-white font-bold px-8 py-4 rounded-full hover:bg-[#e55a25] transition-colors cursor-pointer">
            Find a Store Near Me
          </a>
          <Link to="/products" className="whitespace-nowrap border-2 border-white/30 text-white font-bold px-8 py-4 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
            Shop Online Instead
          </Link>
        </div>
      </div>
    </section>
  );
}
